<template>

  <div v-if="product.price !== null">
    <div class="w-100 h-100">
      <div class="" v-if="product.variation ==0">
        <div class="product-price fa-num" v-if="product.offer>0 || product.offer===null">
          <div class="">
            <del class="price-old">{{ formatNumber(product.price) }}</del>
          </div>
          <span class="price-now">{{ formatNumber(product.price - product.offer) }}<span
              class="currency">تومان</span></span>
        </div>
        <div class="product-price fa-num" v-else>
          <span class="price-now">{{ formatNumber(product.price) }}<span
              class="currency">تومان</span></span>
        </div>
      </div>

      <div class="" v-if="product.variation ==1">
        <div class="product-price fa-num">
          <span class="price-now">{{ getProductPrice(product) }}<span
              class="currency">تومان</span></span>
        </div>
      </div>

    </div>
  </div>


</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {getProductPrice, productPrice} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "price",
  props: ['product'],
  methods: {
    formatNumber,
    productPrice,
    getProductPrice
  }
}
</script>

<style scoped>
.product-price {
  font-size: 15px;
  font-weight: bold !important;
  color: var(--dark) !important;
}

.product-price .discount {
  background-color: var(--light-info);
  border-radius: 25rem;
  color: #fff;
  padding-right: 10px;
  padding-left: 10px;
  font-size: 13px;
}

.product-price .price-old {
  color: gray;
}

.product-price .currency {
  font-size: 13px;
  padding-right: 5px;
  color: var(--gray) !important;
  font-weight: bold !important;
}

.product-card.product-card-horizontal .product-card-body .product-price {
  margin-top: 20px;
}

.price-now {
  color: var(--light-indigo);
}

</style>